<template>
  <a-row :gutter="24" style="margin-top: 8px">
    <a-col :span="4">
      <a-card>
        <a-skeleton
          :active="true"
          :title="false"
          :paragraph="{ rows: 1, width: ['100%'] }"
        />
      </a-card>
    </a-col>
    <a-col :span="4">
      <a-card>
        <a-skeleton
          :active="true"
          :title="false"
          :paragraph="{ rows: 1, width: ['100%'] }"
        />
      </a-card>
    </a-col>
    <a-col :span="4">
      <a-card>
        <a-skeleton
          :active="true"
          :title="false"
          :paragraph="{ rows: 1, width: ['100%'] }"
        />
      </a-card>
    </a-col>
    <a-col :span="4">
      <a-card>
        <a-skeleton
          :active="true"
          :title="false"
          :paragraph="{ rows: 1, width: ['100%'] }"
        />
      </a-card>
    </a-col>
    <a-col :span="4">
      <a-card>
        <a-skeleton
          :active="true"
          :title="false"
          :paragraph="{ rows: 1, width: ['100%'] }"
        />
      </a-card>
    </a-col>
    <a-col :span="4">
      <a-card>
        <a-skeleton
          :active="true"
          :title="false"
          :paragraph="{ rows: 1, width: ['100%'] }"
        />
      </a-card>
    </a-col>
  </a-row>
  <a-row :gutter="24" style="margin-top: 24px">
    <a-col :span="24">
      <a-card>
        <a-skeleton
          :active="true"
          :title="false"
          :paragraph="{ rows: 12, width: ['100%'] }"
        />
      </a-card>
    </a-col>
  </a-row>
  <a-row :gutter="24" style="margin-top: 24px">
    <a-col :span="24">
      <a-card>
        <a-skeleton
          :active="true"
          :title="false"
          :paragraph="{ rows: 12, width: ['100%'] }"
        />
      </a-card>
    </a-col>
  </a-row>
  <a-row :gutter="24" style="margin-top: 24px">
    <a-col :span="24">
      <a-card>
        <a-skeleton
          :active="true"
          :title="false"
          :paragraph="{ rows: 12, width: ['100%'] }"
        />
      </a-card>
    </a-col>
  </a-row>
</template>
